export const SHOW_FREEQUOTE = 'SHOW_FREEQUOTE';
export const GET_AUTH = 'GET_AUTHENTICATION';
export const GET_REDIRECT = 'GET_REDIRECT';
export const SHOW_MENU = 'SHOW_MENU';
export const HIDE_MENU = 'HIDE_MENU';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_REFERRALS = 'SHOW_REFERRALS';
export const HIDE_REFERRALS = 'HIDE_REFERRALS';

export const GET_FIRSTNAME = 'firebase:GET_FIRSTNAME';
export const GET_LASTNAME = 'firebase:GET_LASTNAME';
export const GET_ADDRESS = 'firebase:GET_ADDRESS';
export const GET_CONTRACT = 'firebase:GET_CONTRACT';
export const GET_JOBSTATUS = 'firebase:GET_JOBSTATUS';
export const GET_MONITORING = 'firebase:GET_MONITORING';
export const GET_NEM = 'firebase:GET_NEM';
export const GET_PERMIT = 'firebase:GET_PERMIT';
export const GET_PHONENUMBER = 'firebase:GET_PHONENUMBER';
export const GET_POWRGUARD = 'firebase:GET_POWRGUARD';
export const GET_ROLE = 'firebase:GET_ROLE';
export const GET_SALESREPEMAIL = 'firebase:SALESREPEMAIL';
export const GET_SALESTYPE = 'firebase:GET_SALESTYPE';
export const GET_SALESREP = 'firebase:GET_SALESREP';
export const GET_SITEPLANS = 'firebase:GET_SITEPLANS';
export const GET_SYSTEMSIZE = 'firebase:GET_SYSTEMSIZE';
export const GET_ZIPCODE = 'firebase:GET_ZIPCODE';
export const GET_EMAIL = 'firebase:GET_EMAIL';
export const GET_UID = 'firebase:GET_UID';

export const GET_SAVED = 'firebase:GET_SAVED';
export const GET_CURRENT = 'firebase:GET_CURRENT';
export const GET_ENERGYMONTH = 'firebase:GET_ENERGYMONTH';
export const GET_TODAY = 'firebase:GET_TODAY';
export const GET_LIFETIME = 'firebase:GET_LIFETIME';
export const GET_CO2 = 'firebase:GET_CO2';
export const GET_TREES = 'firebase:GET_TREES';

export const GET_DAILY = 'firebase:GET_DAILY';

export const GET_WEEK = 'firebase:GET_WEEK1';


export const GET_MONTH = 'firebase:GET_MONTH';

//GET CURRENT YEAR
export const GET_ANNUAL = 'firebase:GET_ANNUAL';
export const GET_ANNUALPREVIOUS = 'firebase:GET_ANNUALPREVIOUS';

//get selected month type 
export const GET_SELECTEDMONTH = 'firebase:GET_SELECTEDMONTH';
export const GET_SELECTEDDAY = 'firebase:GET_SELECTEDDAY';
export const GET_SELECTEDDAYFROMWEEK = 'firebase:GET_SELECTEDDAYFROMWEEK';



// WEBPACK FOOTER //
// ./src/Actions/types.js